function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function(theme) {
    return {
        container: {
            base: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                '> *': {
                    marginTop: theme.spacing[4],
                    ':first-of-type': {
                        marginTop: 0
                    }
                }
            },
            fixed: {
                pointerEvents: 'none',
                position: 'fixed',
                alignItems: 'center',
                top: 20,
                width: 'calc(100% - 40px)',
                left: 20,
                right: 20,
                zIndex: theme.depth.zIndex[1600]
            }
        }
    };
};
export var useStyle = function() {
    var builtStyle = useBuildStyleWithTheme(buildStyle);
    if (typeof builtStyle !== 'undefined') {
        var container = builtStyle.container;
        return {
            container: container.base,
            fixedContainer: _objectSpread({}, container.base, container.fixed)
        };
    }
    return {
        container: {},
        fixedContainer: {}
    };
};
